const baseTheme = {
	border: {
		radius: {
			none: '0px',
			xxs: '2px',
			xs: '4px',
			sm: '6px',
			md: '8px',
			lg: '10px',
			xl: '12px',
			'2xl': '16px',
			'3xl': '20px',
			'4xl': '24px',
			full: '9999px',

			// TODO: REMOVE
			2: '2px',
			4: '4px',
			6: '6px',
			8: '8px',
			12: '12px',
			16: '16px',
			24: '24px',
			32: '32px',
		},
	},
	breakpoints: {
		xs: '640px',
		sm: '830px',
		md: '1280px',
		lg: '1500px',
	},
	font: {
		family: {
			default: 'Open Sans, sans-serif',
			secondary: 'Raleway, sans-serif',
		},
		size: {
			10: '10px',
			12: '12px',
			14: '14px',
			16: '16px',
			18: '18px',
			20: '20px',
			22: '22px',
			24: '24px',
			28: '28px',
			32: '32px',
			34: '34px',
			36: '36px',
			42: '42px',
			58: '58px',
			60: '60px',
		},
		weight: {
			light: '300',
			normal: '400',
			medium: '600',
			bold: '700',
			extraBold: '800',
		},
	},
	spacing: {
		none: '0px',
		xxs: '2px',
		xs: '4px',
		sm: '6px',
		md: '8px',
		lg: '12px',
		xl: '16px',
		'2xl': '20px',
		'3xl': '24px',
		'4xl': '32px',
		'5xl': '40px',
		'6xl': '48px',
		'7xl': '64px',
		'8xl': '80px',
		'9xl': '96px',
		'10xl': '128px',
		'11xl': '160px',
	},

	// TODO: REMOVE
	space: {
		0: '0',
		2: '2px',
		4: '4px',
		6: '6px',
		8: '8px',
		12: '12px',
		16: '16px',
		18: '18px',
		24: '24px',
		32: '32px',
		40: '40px',
		48: '48px',
		56: '56px',
		62: '62px',
		64: '64px',
		72: '72px',
		80: '80px',
	},
	shadow: {
		over: {
			10: '0 1px 2px 0 rgba(25, 31, 40, 0.15)',
			20: '0 2px 10px 0 rgba(25, 31, 40, 0.1)',
			30: '0 6px 24px 0 rgba(25, 31, 40, 0.15)',
			40: '0 20px 36px 0 rgba(25, 31, 40, 0.2)',
		},
	},
	zIndex: {
		dropDown: '9',
	},
	iconSize: {
		sm: '16px',
		sl: '20px',
		md: '24px',
		lg: '32px',
	},
	width: {
		xxs: '320px',
		xs: '384px',
		sm: '480px',
		md: '560px',
		lg: '640px',
		xl: '768px',
		'2xl': '1024px',
		'3xl': '1280px',
		'4xl': '1440px',
		'5xl': '1600px',
		'6xl': '1920px',
	},
	containerPadding: {
		mobile: '16px',
		desktop: '24px',
		'max-width-desktop': '1280px',
	},
}

export const theme = {
	...baseTheme,
	color: {
		'bg-page': '#F5F5F5',
		'bg-primary': '#FFFFFF',
		'bg-primary-alt': '#F9F9F9',
		'bg-secondary': '#E9EAEB',
		'bg-tertiary': '#D5D7DA',
		'bg-quaternary': '#A4A7AE',
		'bg-quinary': '#A4A7AE',
		'bg-primary_hover': '#F5F5F5',
		'bg-secondary_hover': '#D5D7DA',
		'bg-tertiary-hover': '#A4A7AE',
		'bg-disabled': '#F5F5F5',
		'bg-always-light': '#FDFDFD',
		'bg-always-dark': '#181D27',
		'bg-negative': '#FDFDFD',
		'bg-overlay': '#00000066',
		'bg-transparency': '#FFFFFF00',

		'fg-primary': '#252B37',
		'fg-secondary': '#414651',
		'fg-tertiary': '#535862',
		'fg-quaternary': '#717680',
		'fg-quinary': '#A4A7AE',
		'fg-senary': '#D5D7DA',
		'fg-setenary': '#E9EAEB',
		'fg-primary_hover': '#181D27',
		'fg-secondary_hover': '#252B37',
		'fg-tertiary_hover': '#414651',
		'fg-quaternary_hover': '#535862',
		'fg-quinary_hover': '#717680',
		'fg-disabled': '#A4A7AE',
		'fg-disabled_subtle': '#D5D7DA',
		'fg-white': '#FFFFFF',
		'fg-black': '#000000',
		'fg-always-light': '#FDFDFD',
		'fg-always-dark': '#181D27',
		'fg-transparency': '#FFFFFF00',

		'brand-50': '#E5F4FF',
		'brand-100': '#B7E2FF',
		'brand-200': '#8ACFFF',
		'brand-300': '#5CBCFF',
		'brand-400': '#2EAAFF',
		'brand-500': '#0097FF',
		'brand-600': '#007FD6',
		'brand-700': '#0063A5',
		'brand-800': '#00497B',
		'brand-900': '#00365A',

		'success-50': '#ECFDF3',
		'success-100': '#DCFAE6',
		'success-200': '#ABEFC6',
		'success-300': '#75E0A7',
		'success-400': '#47CD89',
		'success-500': '#17B26A',
		'success-600': '#079455',
		'success-700': '#067647',
		'success-800': '#085D3A',
		'success-900': '#074D31',

		'warning-50': '#fffaeb',
		'warning-100': '#fef0c7',
		'warning-200': '#fedf89',
		'warning-300': '#fec84b',
		'warning-400': '#fdb022',
		'warning-500': '#f79009',
		'warning-600': '#E7710B',
		'warning-700': '#df5d11',
		'warning-800': '#b3430f',
		'warning-900': '#7A2E0E',

		'error-50': '#fef2f3',
		'error-100': '#fee2e4',
		'error-200': '#fecacd',
		'error-300': '#fd9ba2',
		'error-400': '#f96670',
		'error-500': '#f03844',
		'error-600': '#d9202d',
		'error-700': '#b41823',
		'error-800': '#911820',
		'error-900': '#7A1A20',

		'gray-50': '#F9F9F9',
		'gray-100': '#F5F5F5',
		'gray-200': '#E9EAEB',
		'gray-300': '#D5D7DA',
		'gray-400': '#A4A7AE',
		'gray-500': '#717680',
		'gray-600': '#535862',
		'gray-700': '#414651',
		'gray-800': '#252B37',
		'gray-900': '#181D27',

		'moss-50': '#f5fbee',
		'moss-100': '#E6F4D7',
		'moss-200': '#ceeab0',
		'moss-300': '#ACDC79',
		'moss-400': '#86cb3c',
		'moss-500': '#669f2a',
		'moss-600': '#4f7a21',
		'moss-700': '#3f621a',

		'teal-50': '#f0fdf9',
		'teal-100': '#CCFBEF',
		'teal-200': '#99F6E0',
		'teal-300': '#5fe9d0',
		'teal-400': '#2ED3B7',
		'teal-500': '#15B79E',
		'teal-600': '#0E9384',
		'teal-700': '#107569',

		'cyan-50': '#ECFDFF',
		'cyan-100': '#CFF9FE',
		'cyan-200': '#A5F0FC',
		'cyan-300': '#67E3F9',
		'cyan-400': '#22CCEE',
		'cyan-500': '#06AED4',
		'cyan-600': '#088ab2',
		'cyan-700': '#0E7090',

		'blue-light-50': '#F0F9FF',
		'blue-light-100': '#E0F2FE',
		'blue-light-200': '#B9E6FE',
		'blue-light-300': '#7CD4FD',
		'blue-light-400': '#36BFFA',
		'blue-light-500': '#0BA5EC',
		'blue-light-600': '#0086C9',
		'blue-light-700': '#026AA2',

		'indigo-50': '#EEF4FF',
		'indigo-100': '#E0EAFF',
		'indigo-200': '#C7D7FE',
		'indigo-300': '#A4BCFD',
		'indigo-400': '#8098F9',
		'indigo-500': '#6172F3',
		'indigo-600': '#444CE7',
		'indigo-700': '#3538CD',

		'violet-50': '#F5F3FF',
		'violet-100': '#ECE9FE',
		'violet-200': '#DDD6FE',
		'violet-300': '#C3B5FD',
		'violet-400': '#A48AFB',
		'violet-500': '#875BF7',
		'violet-600': '#7839EE',
		'violet-700': '#6927DA',

		'fuchsia-50': '#FDF4FF',
		'fuchsia-100': '#fbe8ff',
		'fuchsia-200': '#f6d0fe',
		'fuchsia-300': '#EEAAFD',
		'fuchsia-400': '#e478fa',
		'fuchsia-500': '#d444f1',
		'fuchsia-600': '#ba24d5',
		'fuchsia-700': '#9f1ab1',

		'pink-50': '#FDF2F8',
		'pink-100': '#FCE7F4',
		'pink-200': '#FCCEEA',
		'pink-300': '#FAA7D7',
		'pink-400': '#F670BA',
		'pink-500': '#EE46A0',
		'pink-600': '#DD257E',
		'pink-700': '#C11562',

		'orange-50': '#fef6ee',
		'orange-100': '#fdead7',
		'orange-200': '#f9dbaf',
		'orange-300': '#f7b27a',
		'orange-400': '#f38744',
		'orange-500': '#ef6820',
		'orange-600': '#e04f16',
		'orange-700': '#b93815',

		'yellow-50': '#FEFBE8',
		'yellow-100': '#FEF7C3',
		'yellow-200': '#FEEE95',
		'yellow-300': '#FDE272',
		'yellow-400': '#FAC515',
		'yellow-500': '#EAAA08',
		'yellow-600': '#CA8504',
		'yellow-700': '#A15C07',

		'alpha-white-10': '#FFFFFF1A',
		'alpha-white-20': '#FFFFFF33',
		'alpha-white-30': '#FFFFFF4D',
		'alpha-white-40': '#FFFFFF66',
		'alpha-white-50': '#FFFFFF80',
		'alpha-white-60': '#FFFFFF99',
		'alpha-white-70': '#FFFFFFB3',
		'alpha-white-80': '#FFFFFFCC',
		'alpha-white-90': '#FFFFFFE6',
		'alpha-white-100': '#FFFFFF',
		'alpha-black-10': '#0000001A',
		'alpha-black-20': '#00000033',
		'alpha-black-30': '#0000004D',
		'alpha-black-40': '#00000066',
		'alpha-black-50': '#00000080',
		'alpha-black-60': '#00000099',
		'alpha-black-70': '#000000B3',
		'alpha-black-80': '#000000CC',
		'alpha-black-90': '#000000E6',
		'alpha-black-100': '#000000',

		homolog: '#e67e22',
		stage: '#f1c40f',
		dev: '#27ae60',
		brand: {
			dark: '#007FD6',
			pure: '#0097FF',
			medium: '#2AAFFF',
			pale: '#E5F4FF',
		},
		analogue: {
			primary: {
				dark: '#079455',
				pure: '#17B26A',
				medium: '#47CD89',
				pale: '#ECFDF3',
			},
			secondary: {
				dark: '#7839EE',
				pure: '#875BF7',
				medium: '#A48AFB',
				pale: '#F5F3FF',
			},
		},
		moss: {
			dark: '#4F7A21',
			pure: '#669F2A',
			medium: '#86CB3C',
			pale: '#F5FBEE',
		},
		contrast: {
			primary: {
				dark: '#E04F16',
				pure: '#EF6820',
				medium: '#F38744',
				pale: '#FEF6EE',
				transparent: 'rgba(255, 144, 54, 0.15)',
			},
			secondary: {
				dark: '#D9202D',
				pure: '#F03844',
				medium: '#F96670',
				pale: '#FEF2F3',
				transparent: 'rgba(250, 70, 96, 0.15)',
			},
		},
		foreground: {
			secondary: '#414651',
			tertiary: '#535862',
			quaternary: '#717680',
			senary: '#D5D7DA',
			quinary: '#A4A7AE',
		},
		neutral: {
			0: '#FFFFFF',
			10: '#F5F7F8',
			25: '#DDE0E4',
			50: '#B9BCC2',
			75: '#848C9B',
			90: '#4C576C',
			100: '#191F28',
		},
	},
}

export const darkTheme = {
	...baseTheme,
	color: {
		'bg-page': '#141729',
		'bg-primary': '#0A0C14',
		'bg-primary-alt': '#30374F',
		'bg-secondary': '#404968',
		'bg-tertiary': '#4A5578',
		'bg-quaternary': '#5D6B98',
		'bg-quinary': '#5D6B98',
		'bg-primary_hover': '#30374F',
		'bg-secondary_hover': '#4A5578',
		'bg-tertiary-hover': '#5D6B98',
		'bg-disabled': '#252B37',
		'bg-always-light': '#FDFDFD',
		'bg-always-dark': '#181D27',
		'bg-negative': '#FDFDFD',
		'bg-overlay': '#00000066',
		'bg-transparency': '#FFFFFF00',

		'fg-primary': '#FDFDFD',
		'fg-secondary': '#EFF1F5',
		'fg-tertiary': '#DCDFEA',
		'fg-quaternary': '#B9C0D4',
		'fg-quinary': '#7D89B0',
		'fg-senary': '#5D6B98',
		'fg-setenary': '#4A5578',
		'fg-primary_hover': '#FFFFFF',
		'fg-secondary_hover': '#FCFCFD',
		'fg-tertiary_hover': '#EFF1F5',
		'fg-quaternary_hover': '#DCDFEA',
		'fg-quinary_hover': '#B9C0D4',
		'fg-disabled': '#717680',
		'fg-disabled_subtle': '#535862',
		'fg-white': '#FFFFFF',
		'fg-black': '#000000',
		'fg-always-light': '#FDFDFD',
		'fg-always-dark': '#181D27',
		'fg-transparency': '#FFFFFF00',

		'brand-50': '#012844',
		'brand-100': '#00365A',
		'brand-200': '#00497B',
		'brand-300': '#0063A5',
		'brand-400': '#007FD6',
		'brand-500': '#0097FF',
		'brand-600': '#5CBCFF',
		'brand-700': '#8ACFFF',
		'brand-800': '#B7E2FF',
		'brand-900': '#E5F4FF',

		'success-50': '#053321',
		'success-100': '#074D31',
		'success-200': '#085D3A',
		'success-300': '#067647',
		'success-400': '#079455',
		'success-500': '#17B26A',
		'success-600': '#75E0A7',
		'success-700': '#ABEFC6',
		'success-800': '#DCFAE6',
		'success-900': '#ECFDF3',

		'warning-50': '#4E1D09',
		'warning-100': '#7A2E0E',
		'warning-200': '#b3430f',
		'warning-300': '#df5d11',
		'warning-400': '#e7710b',
		'warning-500': '#f79009',
		'warning-600': '#fec84b',
		'warning-700': '#fedf89',
		'warning-800': '#fef0c7',
		'warning-900': '#fffaeb',

		'error-50': '#550C11',
		'error-100': '#7A1A20',
		'error-200': '#911820',
		'error-300': '#b41823',
		'error-400': '#d9202d',
		'error-500': '#f03844',
		'error-600': '#fd9ba2',
		'error-700': '#fecacd',
		'error-800': '#fee2e4',
		'error-900': '#fef2f3',

		'gray-50': '#0A0C14',
		'gray-100': '#141729',
		'gray-200': '#30374F',
		'gray-300': '#404968',
		'gray-400': '#4A5578',
		'gray-500': '#5D6B98',
		'gray-600': '#7D89B0',
		'gray-700': '#B9C0D4',
		'gray-800': '#DCDFEA',
		'gray-900': '#EFF1F5',

		'moss-50': '#1A280B',
		'moss-100': '#2B4212',
		'moss-200': '#335015',
		'moss-300': '#3F621A',
		'moss-400': '#4F7A21',
		'moss-500': '#669F2A',
		'moss-600': '#ACDC79',
		'moss-700': '#CEEAB0',

		'teal-50': '#0A2926',
		'teal-100': '#134E48',
		'teal-200': '#125D56',
		'teal-300': '#107569',
		'teal-400': '#0E9384',
		'teal-500': '#15B79E',
		'teal-600': '#5FE9D0',
		'teal-700': '#99F6E0',

		'cyan-50': '#0D2D3A',
		'cyan-100': '#164C63',
		'cyan-200': '#155B75',
		'cyan-300': '#0E7090',
		'cyan-400': '#088AB2',
		'cyan-500': '#06AED4',
		'cyan-600': '#67E3F9',
		'cyan-700': '#A5F0FC',

		'blue-light-50': '#062C41',
		'blue-light-100': '#0B4A6F',
		'blue-light-200': '#065986',
		'blue-light-300': '#026AA2',
		'blue-light-400': '#0086C9',
		'blue-light-500': '#0BA5EC',
		'blue-light-600': '#7CD4FD',
		'blue-light-700': '#B9E6FE',

		'indigo-50': '#1F235B',
		'indigo-100': '#2D3282',
		'indigo-200': '#2D31A6',
		'indigo-300': '#3538CD',
		'indigo-400': '#444CE7',
		'indigo-500': '#6172F3',
		'indigo-600': '#A4BCFD',
		'indigo-700': '#C7D7FE',

		'violet-50': '#2E125E',
		'violet-100': '#491C96',
		'violet-200': '#5720b7',
		'violet-300': '#6927DA',
		'violet-400': '#7839EE',
		'violet-500': '#875BF7',
		'violet-600': '#C3B5FD',
		'violet-700': '#DDD6FE',

		'fuchsia-50': '#47104C',
		'fuchsia-100': '#6F1877',
		'fuchsia-200': '#821890',
		'fuchsia-300': '#9F1AB1',
		'fuchsia-400': '#BA24D5',
		'fuchsia-500': '#D444F1',
		'fuchsia-600': '#EEAAFD',
		'fuchsia-700': '#F6D0FE',

		'pink-50': '#4E0D2A',
		'pink-100': '#851646',
		'pink-200': '#9E1651',
		'pink-300': '#C11562',
		'pink-400': '#DD2590',
		'pink-500': '#EE46A0',
		'pink-600': '#FAA7D7',
		'pink-700': '#FCCEEA',

		'orange-50': '#511C10',
		'orange-100': '#772917',
		'orange-200': '#932F19',
		'orange-300': '#B93815',
		'orange-400': '#E04F16',
		'orange-500': '#EF6820',
		'orange-600': '#F7B27A',
		'orange-700': '#F9DBAF',

		'yellow-50': '#542C0D',
		'yellow-100': '#713B12',
		'yellow-200': '#854A0E',
		'yellow-300': '#A15C07',
		'yellow-400': '#CA8504',
		'yellow-500': '#EAAA08',
		'yellow-600': '#FDE272',
		'yellow-700': '#FEEE95',

		'alpha-white-10': '#0C0E121A',
		'alpha-white-20': '#0C0E1233',
		'alpha-white-30': '#0C0E124D',
		'alpha-white-40': '#0C0E1266',
		'alpha-white-50': '#0C0E1280',
		'alpha-white-60': '#0C0E1299',
		'alpha-white-70': '#0C0E12B3',
		'alpha-white-80': '#0C0E12CC',
		'alpha-white-90': '#0C0E12E6',
		'alpha-white-100': '#000000',
		'alpha-black-10': '#FFFFFF1A',
		'alpha-black-20': '#FFFFFF33',
		'alpha-black-30': '#FFFFFF4D',
		'alpha-black-40': '#FFFFFF66',
		'alpha-black-50': '#FFFFFF80',
		'alpha-black-60': '#FFFFFF99',
		'alpha-black-70': '#FFFFFFB3',
		'alpha-black-80': '#FFFFFFCC',
		'alpha-black-90': '#FFFFFFE6',
		'alpha-black-100': '#FFFFFF',

		homolog: '#e67e22',
		stage: '#f1c40f',
		dev: '#27ae60',
		brand: {
			dark: '#5CBCFF',
			pure: '#0097FF',
			medium: '#007FD6',
			pale: '#012844',
		},
		analogue: {
			primary: {
				dark: '#75E0A7',
				pure: '#17B26A',
				medium: '#079455',
				pale: '#053321',
			},
			secondary: {
				dark: '#C3B5FD',
				pure: '#875BF7',
				medium: '#7839EE',
				pale: '#2E125E',
			},
		},
		moss: {
			dark: '#ACDC79',
			pure: '#669F2A',
			medium: '#4F7A21',
			pale: '#1A280B',
		},
		contrast: {
			primary: {
				dark: '#F7B27A',
				pure: '#EF6820',
				medium: '#E04F16',
				pale: '#511C10',
				transparent: 'rgba(255, 144, 54, 0.15)',
			},
			secondary: {
				dark: '#FD9BA2',
				pure: '#F03844',
				medium: '#D9202D',
				pale: '#550C11',
				transparent: 'rgba(250, 70, 96, 0.15)',
			},
		},
		foreground: {
			secondary: '#414651',
			tertiary: '#535862',
			quaternary: '#717680',
			senary: '#D5D7DA',
			quinary: '#A4A7AE',
		},
		neutral: {
			0: '#0a111f',
			10: '#13203a',
			25: '#1d2d4e',
			50: '#B9BCC2',
			75: '#dde0e4',
			90: '#f5f7f8',
			100: '#ffffff',
		},
	},
}
